import { ExcelElement } from '../ui/ExcelElement';
import { NextPimField } from './NextPimField';

export class TemplateItem {
  constructor(
    public pimFields: NextPimField[] = [],
    public order?: number,
    public key?: string,
    public seperator?: string,
    public unit?: string,
    public defaultValue?: string,
    public htmlFilter?: boolean,
    public catName?: string,
    public name?: string,
    public previewValues?: string[],
    public calculation: string = "",
    public numberformat: string = "",
    public mapping: string = "",
    public remove: string = "",
    public isNewEditorVersion: boolean = false,
    public addprev: string = "",
    public addfoll: string = ""
  ) {
  }


}
